/**
 * Orgo SDK: Desktop infrastructure for AI agents
 */

export { Project } from './project';
export { Computer } from './computer';
export type {
  ProjectInfo,
  ComputerInfo,
  ComputerConfig,
  ComputerStatus,
  ScreenshotOptions,
  ExecResponse,
  PromptOptions,
  PromptMessage
} from './types';
export { OrgoError, ApiError, ConfigError } from './errors';

// For backward compatibility, also export a helper function
export async function createComputer(options?: {
  projectId?: string;  // This now maps to project name
  apiKey?: string;
  config?: Record<string, unknown>;
  baseApiUrl?: string;
}) {
  const { Computer } = await import('./computer');
  
  // Map old config format to new parameters
  let computerOptions: any = {
    apiKey: options?.apiKey,
    baseApiUrl: options?.baseApiUrl
  };
  
  // Map projectId to project (it's actually a project name now)
  if (options?.projectId) {
    computerOptions.project = options.projectId;
  }
  
  // Extract ram/cpu from config if provided
  if (options?.config) {
    if ('ram' in options.config) {
      computerOptions.ram = options.config.ram as any;
    }
    if ('cpu' in options.config) {
      computerOptions.cpu = options.config.cpu as any;
    }
    if ('os' in options.config) {
      computerOptions.os = options.config.os as any;
    }
    if ('gpu' in options.config) {
      computerOptions.gpu = options.config.gpu as any;
    }
  }
  
  return Computer.create(computerOptions);
}

// Also export a helper function for creating projects
export async function createProject(options?: {
  name?: string;
  apiKey?: string;
  baseApiUrl?: string;
}) {
  const { Project } = await import('./project');
  return Project.create(options);
}